import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import adicionarFiltroPrestador from '../../actions/prestador/adicionarFiltroPrestador'
import removerFiltroPrestador from '../../actions/prestador/removerFiltroPrestador'
import {FILTRO_CPF_CNPJ, FILTRO_NOME, FILTRO_RESPONSAVEL, FILTRO_UF} from '../../util/filtros'
import FiltroBuscaPrestador from './FiltroBuscaPrestador';
import {estados} from '../../util/constantsUtil';

export class FiltroPrestador extends Component {

    adicionarFiltro(filtro) {
        this.props.adicionarFiltroPrestador(filtro)
    }

    removerFiltro(filtro) {
        this.props.removerFiltroPrestador(filtro)
    }

    render() {
        return (
            <React.Fragment>
                <div className="conteudo">
                    <FiltroBuscaPrestador
                        filtro={FILTRO_NOME}
                        opcoes={[]}
                        isNome={true}
                    />
                    <FiltroBuscaPrestador
                        filtro={FILTRO_RESPONSAVEL}
                        opcoes={[]}
                        isNome={true}
                    />
                    <FiltroBuscaPrestador
                        filtro={FILTRO_CPF_CNPJ}
                        isCpf={true}
                    />
                    <FiltroBuscaPrestador
                        filtro={FILTRO_UF}
                        opcoes={estados.map(elemento => elemento.uf)}
                    />
                </div>
            </React.Fragment>
        )
    }
}

export const mapStateToProps = state => ({
    filtrosAdicionados: state.filtrosAdicionadosPrestador,
    empresaSelecionada: state.empresaSelecionada

})

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        adicionarFiltroPrestador,
        removerFiltroPrestador
    }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroPrestador)
